
    var riot = require('riot')
    //src: starling/src/tags/onboarding-popup.html
riot.tag2('onboarding-popup',
  '<div show="{isOpen}" class="onboarding-popup"> <header class="onboarding-popup_header"> <h3 class="onboarding-popup_title"> Welcome to your <br> creative playground! </h3> <svg class="onboarding-popup_close" onclick="{close}"> <use xlink:href="#close-icon"></use> </svg> </header> <section class="onboarding-popup_body"> <article each="{steps}" ref="tip" class="onboarding-item {isCollapsed && \'onboarding-item--collapsed\'} {isCompleted && \'onboarding-item--completed\'}" onclick="{expandSection}"> <i class="onboarding-item_icon fa fa-{isCompleted ? \'check\' : isCollapsed ? \'chevron-right\' : \'chevron-down\'}"></i> <div> <h4 class="onboarding-item_title">{title}</h4> <p hide="{isCollapsed}" class="onboarding-item_description">{description}</p> <video hide="{isCollapsed}" class="onboarding-item_video" riot-src="{video}?v=${config.app_version}" loop></video> </div> </article> </section> </div> <button show="{hasBeenOpened && !isOpen}" class="onboarding-closed" onclick="{open}"> <span>Getting started</span> <svg class="onboarding-closed_icon"> <use xlink:href="#question-icon"></use> </svg> </button>',
  '',
  '', function(opts) {
'use strict';

var _this = this;

this.hasBeenOpened = this.isOpen = false;

var canvas = this.opts.canvas;

canvas.onboardingPopupTag = this;

this.completeStep = function (stepName) {

  var stepIndex = _this.steps.findIndex(function (s) {
    return s.name == stepName;
  });
  if (stepIndex === null) return;
  var step = _this.steps[stepIndex];

  step.isCompleted = true;
  var nextStep = _this.steps.find(function (s) {
    return !s.isCompleted;
  });

  _this.collapseSection({ item: step });

  if (nextStep) {
    _this.expandSection({ item: nextStep });
  }
};

this.steps = [{
  index: 0,
  name: 'create-card',
  title: 'Double-click anywhere to create cards',
  description: 'A card can represent anything – a person, place, object, or any idea at all.',
  video: '/video/card.mp4',
  isCollapsed: true
}, {
  index: 1,
  name: 'drag-drop',
  title: 'Drag and drop cards to group them',
  description: 'You can nest cards inside each other as many levels deep as you like.',
  video: '/video/group.mp4',
  isCollapsed: true
}, {
  index: 2,
  name: 'relate',
  title: 'Drag the arrow to relate cards',
  description: 'Also drag cards onto relationships to label them.',
  video: '/video/line.mp4',
  isCollapsed: true
}];

this.open = function () {
  _this.hasBeenOpened = _this.isOpen = true;
  _this.expandSection({ item: _this.steps[0] });
};

this.close = function () {
  _this.isOpen = false;
  _this.update();
};

this.collapseSection = function (_ref) {
  var item = _ref.item;

  item.isCollapsed = true;
  _this.update();
};

this.expandSection = function (_ref2) {
  var item = _ref2.item;
  var index = item.index,
      isCollapsed = item.isCollapsed;
  var tip = _this.refs.tip;

  _this.steps.filter(function (step) {
    return !step.isCollapsed;
  }).forEach(function (step) {
    var video = tip[step.index].querySelector('video');

    video.pause();
    video.currentTime = 0;

    step.isCollapsed = true;
  });

  item.isCollapsed = false;

  tip[index].querySelector('video').play();

  _this.update();
};
});

    
  if (module.hot) {
    module.hot.accept()
    if (module.hot.data) {
      riot.reload('onboarding-popup')
    }
  }
  


//////////////////
// WEBPACK FOOTER
// ./starling/src/tags/onboarding-popup.html
// module id = 772
// module chunks = 0